import { useState, useCallback } from 'react';
import type { DialogProps } from '@admin/shared/components/dialogs/dialog';
import { Dialog } from '@admin/shared/components/dialogs/dialog';

type DialogHookType = [JSX.Element | JSX.Element[], (opts: DialogProps) => void, () => void];

const renderDialog = (opts: DialogProps | null, handleClose: () => void): JSX.Element => {
  if (opts == null) {
    return null;
  }

  const { children, ...dialogOptions } = opts;

  const onClose = () => {
    if (opts.onClose != null) {
      opts.onClose();
    }

    handleClose();
  };

  return (
    <Dialog {...dialogOptions} onClose={onClose}>
      {children}
    </Dialog>
  );
};

export const useDialog = (): DialogHookType => {
  const [dialogOpts, setDialogOpts] = useState<DialogProps | null>(null);

  const showDialog = useCallback(
    (opts: DialogProps) => {
      setDialogOpts(opts);
    },
    [setDialogOpts],
  );

  const handleClose = () => {
    setDialogOpts(null);
  };

  const dialog = renderDialog(dialogOpts, handleClose);
  return [dialog, showDialog, handleClose];
};
